<template>
  <v-container>
    <!-- List of current types and their distributions-->
    <v-list dense>
      <v-list-item style="font-size: smaller;" class="pl-0">
        <v-list-item-avatar class="pa-1 ma-1" style="width: 96px; bottom: 0px;">
          % of total
        </v-list-item-avatar>
        <v-list-item-content>
          Number of events per category
        </v-list-item-content>
      </v-list-item>
      <v-list-item-group v-model="hidden_items" multiple @change="on_hidden_items_change" color="grey">
        <v-list-item two-line
          v-for="(item, i) in items"
          :key="i"
          class="pl-0"
        >
          <v-list-item-avatar class="pa-1 ma-1" style="width: 96px; bottom: 0px;">
            <v-chip :style="{ 'padding-bottom': '0px', background: color_map[item.name] || color_map.default, color:is_color_dark[item.name] ? 'white' : 'black'}">{{Number(item.value).toFixed(2)}}%</v-chip>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-text="item.name">
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-progress-linear
                :value="item.value"
                color="blue-grey"
                height="25"
                reactive
              >
                <template>
                  <span :style="{ color: item.value > 50 ? 'white' : 'black' }">{{ item.count.toLocaleString() }}</span>
                </template>
              </v-progress-linear>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <div>
      <v-subheader class="pa-2">Hierarchy: </v-subheader>
      <icicle-tree-view
          :data='type_hierarchy'
          :padding="[0, 10, 20, 60]" 
          :width="display.side.width-90"
          :height="300" 
          :color_map="color_map"
          :is_color_dark="is_color_dark"
          ></icicle-tree-view>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import IcicleTreeView from '@/components/IcicleTreeView'
import { ViewType, DiscardEntries, TreeToDisplay } from '@/Config'
import * as treeUtils from '@/treeUtils'
// eslint-disable-next-line
import _, { map } from 'underscore';

export default {
  components: {
    IcicleTreeView,
  },
  data(){
    return {
      hidden_items: [],
      items: [],
      max_events: 100,
      DiscardEntries: DiscardEntries,
    }
  },
  computed: {
    ...mapGetters(['display', 'tree', 'color_map', 'is_color_dark', 'view_type', 'main_view_zoomed_node_id', 'sequence_view_curtree_to_display', 'sequence_view_zoomed_nodes_ids', 'type_hierarchy', 'filter']),
  },
  watch: {
    tree() {
      this.update_items();
    },
    view_type() {
      this.update_items();
    },
    main_view_zoomed_node_id() {
      this.update_items();
    },
    sequence_view_curtree_to_display() {
      this.update_items();
    },
    sequence_view_zoomed_nodes_ids: {
      handler : function() {
        this.update_items();
      },
      deep: true,
    },
    filter: {
      handler: function() {
        this.update_hidden_items();
      },
      deep: true,
    }
  },
  mounted() {
    this.update_items();
  },
  methods: {
    ...mapActions(['set_hidden_items']),
    update_items() {
      //Determine on what node we are currently displaying
      let curNode = null;
      if(this.view_type == ViewType.MAIN_VIEW_TYPE) {
        if(this.main_view_zoomed_node_id <= 0)
          curNode = this.tree;
        else 
          curNode = treeUtils.searchNodeByID(this.tree, this.main_view_zoomed_node_id);
      }
      else if(this.view_type == ViewType.SEQUENCE_VIEW_TYPE) {
        //Search subtree depending on which view we are
        let subtree = null;
        let zoomID  = -1;
        if(this.sequence_view_curtree_to_display == TreeToDisplay.BEFORE) {
          subtree = this.tree.children.length > 0 ? this.tree.children[0].children[1] : null;
          zoomID  = this.sequence_view_zoomed_nodes_ids[0];
        }
        else if(this.sequence_view_curtree_to_display == TreeToDisplay.AFTER) {
          subtree = this.tree.children.length > 0 ? this.tree.children[0].children[0] : null;
          zoomID  = this.sequence_view_zoomed_nodes_ids[1];
        }
        
        if(subtree != null) {
          //Apply the zooming
          if(zoomID <= 0)
            curNode = subtree;
          else
            curNode = treeUtils.searchNodeByID(subtree, zoomID);
        }
      }

      //If no tree --> clear everything
      if(curNode == null) {
        this.items = [];
        return;
      }

      let events = curNode.subcount;
      let items = Object.keys(events)

      //Discard metadata entries
      for(let i = 0; i < items.length; ) {
        if(this.DiscardEntries.includes(items[i]))
          items.splice(i);
        else
          i++;
      }

      items = items.map(d => ({ name: d, count: (d == curNode.name ? events[d] - curNode.count : events[d]) }));
      items = items.filter(d => d.count > 0);
      items = items.sort((a, b) => b.count - a.count);
      let item_counts = items.map(d => d.count);
      let total = item_counts.reduce((a, b) => a + b, 0);
      let max_events = Math.max(...item_counts, 0);
      this.max_events = max_events;
      items.forEach(d => d.value = d.count / total * 100);
      this.items = items;

      this.update_hidden_items();
    },
    update_hidden_items() {
      this.hidden_items = [];
      let tmp = this.filter.hidden_items.map(d => this.items.findIndex((x) => x.name === d));
      for(const el of tmp) {
        if(el >= 0)
          this.hidden_items.push(el);
      }
    },
    on_hidden_items_change() {
      let hidden_items = [...this.filter.hidden_items];
      for(let i = 0; i < this.items.length; i++) {
        let idx = hidden_items.indexOf(this.items[i].name);
        if(!this.hidden_items.includes(i)) {
          if(idx != -1)
            hidden_items.splice(idx, 1);
        }
        else if(idx == -1)
          hidden_items.push(this.items[i].name);
      }
      this.set_hidden_items(hidden_items);
    },
  }
};
</script>
